
import { ROLES_GETTERS } from '@/store/modules/roles';
import { ControlElement } from '@jsonforms/core';
import { rendererProps, RendererProps, useJsonFormsEnumControl } from '@jsonforms/vue';
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';

const controlRenderer = defineComponent({
  name: 'enum-control-renderer',
  components: {},
  props: {
    ...rendererProps<ControlElement>(),
    itemLabel: {
      type: String,
    },
  },
  setup(props: RendererProps<ControlElement>) {
    return useJsonFormsEnumControl(props);
  },
  data() {
    return {
      disable: false,
      loading: false,
      options: [] as Array<{ label: string; value: string }>,
      filteredOptions: [] as Array<{ label: string; value: string }>,
    };
  },
  mounted() {
    if (!this.control.data && this.control.uischema.options?.default) {
      this.control.data = this.control.uischema.options.default;
    }
    if (this.control?.uischema?.options?.key === 'ProjAdmin') {
      this.options = this.adminRoles;
    }
    if (this.control?.uischema?.options?.key === 'ProjContributor') {
      this.options = this.contributorRoles;
    }
    if (this.control?.uischema?.options?.key === 'ProjReader') {
      this.options = this.readerRoles;
    }
    if (this.control?.uischema?.options?.key === 'AlibabaAccounts') {
      this.options = this.alibabaAccounts;
    }
    this.onChange(this.control.data);
  },
  computed: {
    ...mapGetters('roles', {
      adminRoles: ROLES_GETTERS.ADMIN_ROLES,
      contributorRoles: ROLES_GETTERS.CONTRIBUTOR_ROLES,
      readerRoles: ROLES_GETTERS.READER_ROLES,
      alibabaAccounts: ROLES_GETTERS.ALIBABA_ACCOUNTS,
    }),
  },
  methods: {
    filterFn(val: any, update: any) {
      if (val === '') {
        update(() => {
          this.filteredOptions = this.options;
        });
        return;
      }
      update(() => {
        const needle = val.toLowerCase();
        this.filteredOptions = this.options.filter(
          (v) => v.label.toLowerCase().indexOf(needle) > -1 || v?.value.toLowerCase().indexOf(needle) > -1,
        );
      });
    },
    onChange(value: any) {
      this.handleChange(this.control.path, value);
    },
  },
});

export default controlRenderer;
